import { render, staticRenderFns } from "./tlj.vue?vue&type=template&id=65d939f1&scoped=true"
import script from "./tlj.vue?vue&type=script&lang=js"
export * from "./tlj.vue?vue&type=script&lang=js"
import style0 from "./tlj.vue?vue&type=style&index=0&id=65d939f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d939f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d939f1')) {
      api.createRecord('65d939f1', component.options)
    } else {
      api.reload('65d939f1', component.options)
    }
    module.hot.accept("./tlj.vue?vue&type=template&id=65d939f1&scoped=true", function () {
      api.rerender('65d939f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shoppingGift/tljPromotionposition/components/tlj.vue"
export default component.exports